import React from 'react';
import {Box, Chip, MenuItem, Paper, Tooltip, Typography} from "@mui/material";
import {translate} from "../../../translate/translate";
import TablePaginationComponent from "../../../components/table/table-pagination.component";
import {ImportAmortizationService} from "../../../services/import-integration-routines-service";
import {IntegrationRoutines, mapStatusColor, mapStatusString} from "../../../models/basic/integration-routines";
import {Refresh, Visibility} from "@mui/icons-material";
import ExecuteManualRfcComponent from "./execute-manual-rfc.component";
import ExecutionLogRfcComponent from "./execution-log-rfc.component";

const ImportIntegrationRoutinesComponent = () => {
    const service = new ImportAmortizationService()
    const [dataSource, setDataSource] = React.useState<IntegrationRoutines[]>([]);
    const [loading, setLoading] = React.useState<boolean>(false);

    const [openDialogExecuteRfc, setOpenDialogExecuteRfc] = React.useState<boolean>(false);
    const [openDialogViewLog, setOpenDialogViewLog] = React.useState<boolean>(false);
    const [selectedRfc, setSelectedRfc] = React.useState<IntegrationRoutines | null>(null);

    React.useEffect(() => {
        fetchDataSource();
    }, []);

    const fetchDataSource = async () => {
        setLoading(true);
        setDataSource([]);
        service.readAll().then(res => {
            setDataSource(res.data);
        }).catch(err => {
            console.error("Error fetching integration routines:", err);
        }).finally(() => {
            setLoading(false);
        });
    }

    const customCellRender = (column: string, index: number, row: IntegrationRoutines) => {
        if (column === "status") {
            if (row.status.toString() === '-' ) return "-";
            return <Tooltip title={row.last_error_message} placement="top">
                <Chip size="small"
                      color={mapStatusColor[row.status] as any}
                      label={translate.t(mapStatusString[row.status])}
                />
            </Tooltip>
        }

        if (column === "ultima_execucao") {
            if (!row.ultima_execucao || row.ultima_execucao === '-') return "-";

            const dateStr = row.ultima_execucao.endsWith('Z')
                ? row.ultima_execucao
                : row.ultima_execucao + 'Z';

            const date = new Date(dateStr);
            return date.toLocaleString([], {
                timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                dateStyle: 'short',
                timeStyle: 'medium'
            });
        }

        return row[column as keyof IntegrationRoutines];
    }

    const customMenuItems = (row: any) => {
        return (
            <>
                <MenuItem
                      onClick={()  => {
                          setSelectedRfc(row);
                          setOpenDialogExecuteRfc(true);
                      }}>
                    <Refresh />
                    <Typography variant="body1" marginLeft={1}>
                        Executar
                    </Typography>
                </MenuItem>
                <MenuItem
                    disabled={row.id == -1}
                    onClick={()  => {
                        setSelectedRfc(row);
                        setOpenDialogViewLog(true);
                    }}>
                    <Visibility/>
                    <Typography variant="body1" marginLeft={1}>
                        Ver Log
                    </Typography>
                </MenuItem>
            </>
        )
    }

    return (
        <section>
            <div className="floating-title" style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                <Typography variant={"h5"}>
                    {translate.t("integration_routines")}
                </Typography>
            </div>

            <Paper variant="outlined" sx={{marginTop: "16px"}}>
                <Box padding={2}>
                    <Typography variant="body1" fontWeight="bold" gutterBottom>
                        Gerencie e execute manualmente as rotinas de integração via RFC com o SAP.
                        Caso algum job automático falhe, você pode executar manualmente aqui.
                    </Typography>
                </Box>
                <TablePaginationComponent
                    state={dataSource}
                    displayedColumnsShow={["RFC", "description", "status", "Data última execução", "actions"]}
                    displayedColumns={["rfc", "descricao", "status", "ultima_execucao", "action"]}
                    customColumns={["status", "ultima_execucao"]}
                    // dateColumns={["ultima_execucao"]}
                    customCellRender={customCellRender}
                    loading={loading}
                    customMenuItems={customMenuItems}
                    menuLayout={true}
                    showActions={["custom"]}
                />
            </Paper>

            <ExecuteManualRfcComponent
                openDialog={openDialogExecuteRfc}
                handleCloseDialog={() => {
                    setOpenDialogExecuteRfc(false);
                    setSelectedRfc(null);
                    fetchDataSource();
                }}
                rfc={selectedRfc}
            />

            <ExecutionLogRfcComponent
                openDialog={openDialogViewLog}
                handleCloseDialog={() => {
                    setOpenDialogViewLog(false);
                    setSelectedRfc(null);
                }}
                rfc={selectedRfc}
            />
        </section>
    );
}

export default ImportIntegrationRoutinesComponent;
